export default __webpack_public_path__ + "static/media/LogoBlue.c7ddba35.svg";